import PubSub from "underpub-js";

var HighlightFeatures = function (options) {

  this.options = {
    $el: false,
    baseClass: 'mol-HighlightFeatures',
  };

  $.extend(true, this.options, options);

};

HighlightFeatures.prototype.init = function () {

  var self = this;

  self.$images = self.options.$el.find(`.${self.options.baseClass}__images`);
  self.$image = self.options.$el.find(`.${self.options.baseClass}__image`);
  self.$prevArrow = self.options.$el.find(`.${self.options.baseClass}__arrow--prev`);
  self.$nextArrow = self.options.$el.find(`.${self.options.baseClass}__arrow--next`);

  if (self.$image.length > 1) {
    self.$images.slick({
      prevArrow: self.$prevArrow,
      nextArrow: self.$nextArrow,
      swipe: true,
    });
  }

};

export default HighlightFeatures;